//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
  NotificationManager,
  NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";

//Actions
import { manageDeleteManageEquipment, reset } from "./redux/slice";
import { useDispatch, useSelector } from "react-redux";

const DeleteManageEquipment = ({ refresh }) => {
  //Redux
  const dispatch = useDispatch();
  const { open, loading, result, error, deleteEquipment, deleteEquipmentList } =
    useSelector((state) => state.manageDeleteManageEquipmentRedux);

  //Language
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => dispatch(reset()), []);

  const handleDeleteSubmit = useCallback(() => {
    if (deleteEquipment) {
      dispatch(manageDeleteManageEquipment({ id: deleteEquipment?.id }));
      return;
    }
    if (deleteEquipmentList?.length) {
      dispatch(manageDeleteManageEquipment({ items: deleteEquipmentList }));
    }
  }, [deleteEquipment, deleteEquipmentList]);

  //Effects
  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    );
    dispatch(reset({ error: null }));
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess = deleteEquipment
      ? messages["manage_deletedEquipment"]
      : messages["manage_deletedEquipments"];
    NotificationManager.success(
      messageSuccess,
      messages["success"],
      3000,
      null,
      null,
      "success"
    );
    refresh();
    dispatch(reset());
  }, [result]);

  return (
    <Modal
      title={
        deleteEquipment
          ? messages["manage_deleteManageEquipment_deleteEquipment"]
          : messages["manage_deleteManageEquipment_deleteEquipments"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button
            variant="warning"
            onClick={() => handleDeleteSubmit()}
            isDisabled={loading}
          >
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteManageEquipment_confirmationMessage"]}</p>
        <ul>
          {deleteEquipment ? (
            <li>{deleteEquipment?.name}</li>
          ) : (
            deleteEquipmentList.map((equipment) => <li>{equipment.name}</li>)
          )}
        </ul>
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageEquipment;
